<template>
    <v-card>
        <v-card-title>
            <div class="card-title-text">
                <span class="body-2 font-weight-bold">Aktív</span><br>
                <span class="display-1 font-weight-thin">Felhasználó lista</span>
            </div>
                <div class="flex-grow-1"></div>
                <v-text-field
                        v-if="!this.$vuetify.breakpoint.xs && !this.$vuetify.breakpoint.sm"
                        name="search"
                        v-model="search"
                        label="Keresés"
                        append-icon="search"
                        outlined
                />
        </v-card-title>
        <v-simple-table v-if="this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm">
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">Felhasználó</th>
                    <th class="text-left" style="padding: 0;">Utolsó aktivitás</th>
                </tr>
                </thead>
                <tbody>
                <tr  v-for="item in userList" :key="item.name">
                    <td style="height: 35px; padding-left: 5px; padding-right: 0px;">
                        <v-btn v-if="item.active === 1" text icon color="#27ae60" @click.prevent="kickOutUser(item.id)" ><v-icon small>mdi-checkbox-marked-circle</v-icon></v-btn>
                        <v-btn v-else text icon color="#c0392b" @click.prevent="kickOutUser(item.id)" ><v-icon small>mdi-close-circle</v-icon></v-btn>
                        <router-link :to="`/user-detail/${item.id}`" :class="[item.log_type == 1 ? 'user-is-working' : 'user-is-breaking', 'user-list-detail-link']" style="font-size: 13px;">
                            <v-icon small v-if="item.log_type == 2">mdi-coffee</v-icon>
                            <v-icon small v-else >mdi-briefcase</v-icon>
                            {{ item.name }}
                        </router-link>
                    </td>
                    <td style="height: 35px; padding: 0;">
                        <span style="font-size: 11px">{{ item.timestamp }}</span>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-data-table
                v-else
                :headers="headers"
                :items="userList"
                :loading="loading"
                :items-per-page="30"
                :search="search"
                loading-text="Betöltés..."
        >
            <template v-slot:item.active="{ item }">
                <v-btn v-if="item.active === 1" text icon color="#27ae60" @click.prevent="kickOutUser(item.id)" ><v-icon>mdi-checkbox-marked-circle</v-icon></v-btn>
                <v-btn v-else text icon color="#c0392b" @click.prevent="kickOutUser(item.id)" ><v-icon>mdi-close-circle</v-icon></v-btn>
            </template>

            <template v-slot:item.name="{ item }">
                <router-link :to="`/user-detail/${item.id}`" :class="[item.log_type == 1 ? 'user-is-working' : 'user-is-breaking', 'user-list-detail-link']">
                    <v-icon v-if="item.log_type == 2">mdi-coffee</v-icon>
                    <v-icon v-else>mdi-briefcase</v-icon>
                    {{ item.name }}
                </router-link>
            </template>

            <template v-slot:item.average_hour="{ item }">
                {{ item.average_hour.work }}
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import Pusher from 'pusher-js'
    export default {
        name: "EmployeeList",

        data () {
            return {
                userList: [],
                loading: true,
                search: '',
                headers: [
                    {
                      text: 'Állapot',
                      align: 'center',
                      sortable: false,
                      value: 'active'
                    },
                    {
                        text: 'Név',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },

                    {
                        text: 'Kirugások',
                        align: 'center',
                        sortable: false,
                        value: 'kicks_count'
                    },
                    {
                        text: 'Átlag óra',
                        align: 'left',
                        sortable: true,
                        value: 'average_hour'
                    }
                ]
            }
        },

        mounted() {
            this.getActiveUserList()
            this.subscribe()
        },

        methods: {
            async getActiveUserList() {
                await this.$axios({ url: '/user-active-list', method: 'GET' })
                    .then(resp => {
                        this.userList = resp.data.data
                        this.loading = false
                    })
            },

            async kickOutUser(id_user) {
                this.loading = true
                await this.$axios({ url: '/kick-out-user', method: 'POST', data: {id_user: id_user} })
                    .then(resp => {
                        let objIndex = this.userList.findIndex((obj => obj.id == resp.data.data.id))
                        this.userList[objIndex].active = resp.data.data.active
                        this.userList[objIndex].kicks_count = resp.data.data.kicks_count

                        this.loading = false
                    })
            },

            subscribe () {
                let pusher = new Pusher('a66417eeea6d919eb1d3', { cluster: 'eu' })
                pusher.subscribe('employee-channel')
                pusher.bind('employee-channel', data => {
                    let objIndex = this.userList.findIndex((obj => obj.id == data.message.user));
                    this.userList[objIndex].log_type = data.message.log_type;
                    this.userList[objIndex].timestamp = data.message.time;
                })
            },
        }
    }
</script>

<style lang="scss">
    .card-title-text { margin-top: -20px; }

    .user-list-detail-link {
        text-decoration: none;
        font-weight: 600;

        &.user-is-breaking {
            color: #c0392b;
            i { color: #c0392b; }
        }
        &.user-is-working {
            color: #27ae60;
            i { color: #27ae60; }
        }
    }
</style>
